import { DateRange, Option, SplitBy } from "@intentsify/types";
import { atom } from "jotai";
import { atomWithReset, useResetAtom } from "jotai/utils";
import { ViewEnum } from "screens/IntentAnalysis/screens/CampaignsTrendingDomains/CampaignsTrendingDomains.types";
import { TopPerformingDomainsOptions } from "./TopPerformingDomains.types";

export const topPerformingDomainsDateRangeAtom = atomWithReset<DateRange>(
  DateRange.LastFourWeeks
);

export const topPerformingDomainsSplitByAtom = atomWithReset<SplitBy>(
  SplitBy.OneWeek
);

export const topPerformingDomainsViewAtom = atomWithReset<ViewEnum>(
  ViewEnum.Table
);

export const topPerformingSelectedDomainsAtom = atomWithReset<{
  campaignId: number | undefined;
  data: Array<Option<number>>;
}>({
  campaignId: undefined,
  data: [],
});

export const performingDomainsOptionsStateAtom =
  atomWithReset<TopPerformingDomainsOptions>({
    isLoading: true,
    topPerformingDomains: [],
  });

export const topPerformingDomainsStateSelector = atom((get) => {
  const { isLoading, topPerformingDomains } = get(
    performingDomainsOptionsStateAtom
  );
  const selectedDateRange = get(topPerformingDomainsDateRangeAtom);
  const selectedSplitBy = get(topPerformingDomainsSplitByAtom);
  const selectedView = get(topPerformingDomainsViewAtom);
  const selectedDomains = get(topPerformingSelectedDomainsAtom);

  return {
    isLoading,
    topPerformingDomainsOptions: topPerformingDomains,
    selectedDateRange,
    selectedSplitBy,
    selectedView,
    selectedDomains,
  };
});

export const useResetTopPerformingState = () => {
  const resetOptions = useResetAtom(performingDomainsOptionsStateAtom);
  const resetDateRange = useResetAtom(topPerformingDomainsDateRangeAtom);
  const resetSplitBy = useResetAtom(topPerformingDomainsSplitByAtom);
  const resetView = useResetAtom(topPerformingDomainsViewAtom);
  const resetDomains = useResetAtom(topPerformingSelectedDomainsAtom);

  return () => {
    resetOptions();
    resetDateRange();
    resetSplitBy();
    resetView();
    resetDomains();
  };
};
